module.exports = __webpack_public_path__ + "static/media/img_cat_small.39ded3c1.svg";